import { ApiClientBase } from './ApiClientBase';

export class BffApiClient extends ApiClientBase {
  private static instance: BffApiClient;
  /**
   * Singleton instance of BffApiClient
   */
  constructor() {
    super(import.meta.env.VITE_API_BASE_URL);
  }

  static getInstance(): BffApiClient {
    if (!this.instance) {
      this.instance = new BffApiClient();
    }
    return this.instance;
  }
}
